/* Diente — "Vazute recent" list, kept in localStorage.

   Cards are built with DOM nodes rather than an innerHTML string: the stored
   payload is product data (titles routinely contain & " < >), and string
   concatenation both mangled those titles and made the block an injection
   surface for anything ever written into localStorage. */
(function () {
  'use strict';

  var KEY = 'im_recent';
  var MAX = 6;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      /* private mode / quota — this page view still renders correctly */
    }
  }

  function remember(entry) {
    if (!entry || !entry.handle) return;
    var list = read().filter(function (item) {
      return item.handle !== entry.handle;
    });
    list.unshift(entry);
    write(list.slice(0, MAX));
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function buildCard(item) {
    var link = el('a', 'mini-card');
    link.href = item.url || '#';

    var media = el('div', 'mini-card__media');
    if (item.image) {
      var image = el('img', 'card__image');
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    } else {
      media.appendChild(el('div', 'card__placeholder'));
    }

    var body = el('div', 'mini-card__body');
    body.appendChild(el('div', 'mini-card__title', item.title || ''));

    var price = el('div', 'mini-card__price', item.price != null ? String(item.price) : '');
    if (item.currency) {
      price.appendChild(document.createTextNode(' '));
      price.appendChild(el('span', 'mini-card__currency', item.currency));
    }
    body.appendChild(price);

    link.appendChild(media);
    link.appendChild(body);
    return link;
  }

  function render() {
    var mount = document.querySelector('[data-recently-viewed]');
    if (!mount) return;

    var currentHandle = mount.getAttribute('data-current-handle');
    var list = read().filter(function (item) {
      return item && item.handle !== currentHandle;
    });

    var grid = mount.querySelector('[data-recently-viewed-grid]');
    if (!grid || !list.length) {
      mount.hidden = true;
      return;
    }

    grid.textContent = '';
    var fragment = document.createDocumentFragment();
    list.forEach(function (item) {
      fragment.appendChild(buildCard(item));
    });
    grid.appendChild(fragment);

    mount.hidden = false;
    document.dispatchEvent(new CustomEvent('product-carousel:render'));
  }

  function start() {
    var data = document.getElementById('RecentlyViewedProduct');
    if (data) {
      try {
        remember(JSON.parse(data.textContent));
      } catch (error) {
        /* ignore malformed payload */
      }
    }
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();